import React from 'react'
import HelpCard from '../components/Cards/HelpCard'
import Footer from '../components/layout/Footer'
import Navbar from './Navbar'
import HelpUsData from '../Data/helpusdata'
const HelpUs = () => {
    console.log(HelpUsData);
  return (
    <div>
        <Navbar/>

        <div className='w-full lg:px-32 md:px-20  px-4 py-12'>

            <HelpCard Topic={HelpUsData.Registration} TopicName="Registration"/>
            <HelpCard Topic={HelpUsData.Login} TopicName="Login / Account Related"/>
            <HelpCard Topic={HelpUsData.ProductPrice} TopicName="Product / Price / Promotion"/>
            <HelpCard Topic={HelpUsData.Ordering} TopicName="Ordering"/>
            <HelpCard Topic={HelpUsData.Payment} TopicName="Payment"/>
            <HelpCard Topic={HelpUsData.Delivery} TopicName="Delivery"/>
            <HelpCard Topic={HelpUsData.LoyaltyProgram} TopicName="LoyaltyProgram"/>
        </div>
        <Footer/>
    </div>
  )
}

export default HelpUs